import { render, staticRenderFns } from "./DishPrice.vue?vue&type=template&id=43efb6c4&scoped=true&lang=pug"
import script from "./DishPrice.vue?vue&type=script&lang=js"
export * from "./DishPrice.vue?vue&type=script&lang=js"
import style0 from "./DishPrice.vue?vue&type=style&index=0&id=43efb6c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efb6c4",
  null
  
)

export default component.exports